import React from 'react';
import Divider from '@mui/material/Divider';


export default function VerticalDivider() {
  return (
    <Divider orientation="vertical" flexItem sx={{p: 0, marginLeft: '-1px', marginRight: '-1px'}}/>
  );
}
